import type { SVGProps } from 'react';

export const SvgIconQuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4446_2560)">
      <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"></circle>
      <path
        d="M8 12.3C8.55228 12.3 9 11.8523 9 11.3C9 10.7477 8.55228 10.3 8 10.3C7.44772 10.3 7 10.7477 7 11.3C7 11.8523 7.44772 12.3 8 12.3Z"
        fill="currentColor"></path>
      <path
        d="M8 8.79999V8.29999C8.34612 8.29999 8.68446 8.19735 8.97225 8.00506C9.26003 7.81277 9.48434 7.53946 9.61679 7.21968C9.74924 6.89991 9.7839 6.54805 9.71637 6.20858C9.64885 5.86911 9.48218 5.55729 9.23744 5.31255C8.9927 5.06781 8.68087 4.90114 8.34141 4.83361C8.00194 4.76609 7.65007 4.80075 7.3303 4.9332C7.01053 5.06565 6.73722 5.28995 6.54493 5.57774C6.35264 5.86553 6.25 6.20387 6.25 6.54999"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"></path>
    </g>
    <defs>
      <clipPath id="clip0_4446_2560">
        <rect width="16" height="16" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
);
